// extracted by mini-css-extract-plugin
module.exports = {"root":"TagsInput_root__3ppqK","inputWrapper":"TagsInput_inputWrapper__2KcyE","errorLabel":"TagsInput_errorLabel__3CDPH"};